import { StoreItemEnum as t } from "../../../enums/store-item-enum.mjs";
const e = {
  type: t.link,
  url: "",
  title: "Check it out!",
  subTitle: `Visit my Affiliate Link \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null
};
export {
  e as defaultLinkValues
};
